import { render, staticRenderFns } from "./simple-header.vue?vue&type=template&id=3acbc2e8&scoped=true&"
import script from "./simple-header.vue?vue&type=script&lang=js&"
export * from "./simple-header.vue?vue&type=script&lang=js&"
import style0 from "./simple-header.vue?vue&type=style&index=0&id=3acbc2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acbc2e8",
  null
  
)

export default component.exports